import { create } from 'zustand';

type Store = {
  // channeltalk boot 여부
  enableChannelTalk: boolean;
  // boot 이후 channeltalk 버튼 노출 여부
  isChannelShow: boolean;
};

export const ChannelTalkStore = create<Store>()(() => ({
  isChannelShow: false,
  enableChannelTalk: false,
}));

export function getEnableChannelTalk() {
  return ChannelTalkStore.getState().enableChannelTalk;
}

export function useEnableChannelTalk() {
  return ChannelTalkStore((store) => store.enableChannelTalk);
}

export function useIsChannelShow() {
  return ChannelTalkStore((store) => store.isChannelShow);
}

export function setIsChannelShow(isChannelShow: boolean) {
  ChannelTalkStore.setState({ isChannelShow });
}

export function initChannelTalk(initialValue: boolean) {
  ChannelTalkStore.setState({ isChannelShow: initialValue, enableChannelTalk: initialValue });
}
